import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Cliente, ClienteRequest } from "@/shared/types/cliente";

export async function addCliente(request: ClienteRequest): Promise<Cliente> {
    await sleep(1000);
    const response = await api.post("clientes/fe", request);
    return response.data;
}

export function useAddClienteMutation(mutationConfig: MutationConfig<Cliente, ClienteRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addCliente,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["clientes"] });
        },
    })
}

export interface AddClienteMutationProps {
    mutationConfig?: MutationConfig<Cliente, ClienteRequest>
    children?: (mutationResult: MutationResult<Cliente, ClienteRequest>) => ReactNode
}

export function AddClienteMutation({
    mutationConfig,
    children
}: AddClienteMutationProps) {
    const mutationResult = useAddClienteMutation(mutationConfig);
    return children && children(mutationResult);
}